class Timer {
  constructor(callback, delay) {
    this.timerId = null;
    this.start = null;
    this.callback = callback;
    this.delay = delay;
    this.remaining = delay;
    this.resume();
  }

  pause() {
    clearTimeout(this.timerId);
    this.remaining -= Date.now() - this.start;
  }

  resume() {
    this.start = Date.now();
    clearTimeout(this.timerId);
    this.timerId = setTimeout(this.callback, this.remaining);
  }
}

export default Timer;
